"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var list_1 = require("../utils/list");
var BaseService_1 = require("../BaseService");
var Retainable_1 = require("../Retainable");
var extractErrorMessage_1 = require("../extractErrorMessage");
var AuthenticationService_1 = require("../AuthenticationService");
var RtService_1 = require("../RtService");
function makeModel(error, loading, tableName, entities) {
    if (entities === void 0) { entities = []; }
    var model = entities;
    model.error = error;
    model.loading = loading;
    model.entities = entities;
    model[tableName] = entities;
    return model;
}
var BaseEntitiesService = /** @class */ (function (_super) {
    __extends(BaseEntitiesService, _super);
    function BaseEntitiesService(repo) {
        var _this = _super.call(this, makeModel('', true, repo.getTableName(), [])) || this;
        _this._onRtMessage = function (messageType, payload) {
            console.log('RECEIVED rt message', messageType, payload);
            var tableName = _this._repo.getTableName().toUpperCase();
            if (messageType === 'CREATE_' + tableName)
                _this._onRtMessageCreate([payload]);
            else if (messageType === 'CREATE_' + tableName + 'S')
                _this._onRtMessageCreate(payload);
            else if (messageType === 'ADD_' + tableName)
                _this._onRtMessageCreate([payload]);
            else if (messageType === 'ADD_' + tableName + 'S')
                _this._onRtMessageCreate(payload);
            else if (messageType === 'UPDATE_' + tableName)
                _this._onRtMessageUpdate([payload]);
            else if (messageType === 'UPDATE_' + tableName + 'S')
                _this._onRtMessageUpdate(payload);
            else if (messageType === 'DELETE_' + tableName)
                _this._onRtMessageDelete([payload]);
            else if (messageType === 'DELETE_' + tableName + 'S')
                _this._onRtMessageDelete(payload);
            else if (messageType === 'REMOVE_' + tableName)
                _this._onRtMessageDelete([payload]);
            else if (messageType === 'REMOVE_' + tableName + 'S')
                _this._onRtMessageDelete(payload);
        };
        _this._repo = repo;
        _this._schemaName = _this._repo.getSchemaName();
        _this._tableName = _this._repo.getTableName();
        _this._subscriptions.push(RtService_1.RtService.getInstance().subscribeDataset(_this._schemaName, _this._onRtMessage));
        _this._subscriptions.push(AuthenticationService_1.AuthenticationService.subscribeUpdatesAndNotify(function () { return _this._init(); }));
        return _this;
    }
    BaseEntitiesService.prototype.save = function (entity) {
        return __awaiter(this, void 0, void 0, function () {
            var id;
            return __generator(this, function (_a) {
                if (this._model.error)
                    throw new Error('Invoke create on error service');
                if (this._model.loading)
                    throw new Error('Invoke create on loading service');
                if (entity.id) {
                    id = entity.id;
                    delete entity.id;
                    return [2 /*return*/, this.updateOne(id, entity)];
                }
                else {
                    delete entity.id;
                    return [2 /*return*/, this.create(entity)];
                }
                return [2 /*return*/];
            });
        });
    };
    BaseEntitiesService.prototype.create = function (partialEntity) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._model.error)
                    throw new Error('Invoke create on error service');
                if (this._model.loading)
                    throw new Error('Invoke create on loading service');
                return [2 /*return*/, this._create(partialEntity)];
            });
        });
    };
    BaseEntitiesService.prototype.updateOne = function (id, partialEntity) {
        if (this._model.error)
            throw new Error('Invoke updateOne on error service');
        if (this._model.loading)
            throw new Error('Invoke updateOne on loading service');
        return this._updateOne(id, partialEntity);
    };
    BaseEntitiesService.prototype.remove = function (id) {
        if (this._model.error)
            throw new Error('Invoke remove on error service');
        if (this._model.loading)
            throw new Error('Invoke remove on loading service');
        return this._remove(id);
    };
    BaseEntitiesService.prototype._repoListInternal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var entities;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._repo.list()];
                    case 1:
                        entities = _a.sent();
                        return [2 /*return*/, entities];
                }
            });
        });
    };
    //
    //
    //
    BaseEntitiesService.prototype._init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var authModel, entities, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authModel = AuthenticationService_1.AuthenticationService.getModel();
                        if (authModel.error)
                            return [2 /*return*/, this._updateModel({ error: authModel.error, loading: false })];
                        if (authModel.loading)
                            return [2 /*return*/, this._updateModel({ error: null, loading: true })];
                        if (!authModel.authenticated)
                            return [2 /*return*/, this._updateModel({ error: AuthenticationService_1.AuthenticationService.NOT_AUTHENTICATED, loading: false })];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._repoListInternal()];
                    case 2:
                        entities = _a.sent();
                        this._setModel(makeModel('', false, this._tableName, entities));
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this._setModel(makeModel(extractErrorMessage_1.extractErrorMessage(err_1), false, this._tableName, []));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BaseEntitiesService.prototype._updateModel = function (partialModel) {
        throw new Error('BaseEntitiesService::_updateModel not implemented');
    };
    BaseEntitiesService.prototype._create = function (partialEntity) {
        return __awaiter(this, void 0, void 0, function () {
            var e;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        delete partialEntity.id;
                        return [4 /*yield*/, this._repo.create(partialEntity)];
                    case 1:
                        e = _a.sent();
                        this._updateInternalOneEntity(e);
                        // send real time message
                        RtService_1.RtService.publishDsMessage(this._schemaName, 'CREATE_' + this._tableName.toUpperCase(), e);
                        return [2 /*return*/, e];
                }
            });
        });
    };
    BaseEntitiesService.prototype._updateOne = function (id, entity) {
        return __awaiter(this, void 0, void 0, function () {
            var e, idx, entities;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._repo.update(id, __assign(__assign({}, entity), { id: undefined }))];
                    case 1:
                        e = _a.sent();
                        idx = list_1.$eidx(this._model.entities, id);
                        entities = this._model.entities.slice(0);
                        if (idx !== -1) {
                            entities[idx] = e;
                        }
                        this._setModel(makeModel(this._model.error, this._model.loading, this._tableName, entities));
                        // send real time message
                        RtService_1.RtService.publishDsMessage(this._schemaName, 'UPDATE_' + this._tableName.toUpperCase(), e);
                        return [2 /*return*/, e];
                }
            });
        });
    };
    BaseEntitiesService.prototype._remove = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // maybe remove before request, and insert on fail to prevent data races
                    return [4 /*yield*/, this._repo.remove(id)];
                    case 1:
                        // maybe remove before request, and insert on fail to prevent data races
                        _a.sent();
                        this._deleteInternalOneEntity(id);
                        // send real time message
                        RtService_1.RtService.publishDsMessage(this._schemaName, 'DELETE_' + this._tableName.toUpperCase(), { id: id });
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseEntitiesService.prototype._onRtMessageCreate = function (es) {
        var _this = this;
        es.forEach(function (e) { return _this._updateInternalOneEntity(e); }); // TODO: _updateInternalManyEntities
    };
    BaseEntitiesService.prototype._onRtMessageUpdate = function (es) {
        var _this = this;
        es.forEach(function (e) { return _this._updateInternalOneEntity(e); }); // TODO: _updateInternalManyEntities
    };
    BaseEntitiesService.prototype._onRtMessageDelete = function (es) {
        var _this = this;
        es.forEach(function (e) { return _this._deleteInternalOneEntity(e.id); }); // TODO: _deleteInternalManyEntities
    };
    BaseEntitiesService.prototype._updateInternalOneEntity = function (e) {
        var id = e.id;
        var idx = list_1.$eidx(this._model.entities, id);
        var entities = this._model.entities.slice(0);
        if (idx !== -1) {
            // existent entity
            entities[idx] = e;
        }
        else {
            // new entity
            entities.push(e);
        }
        this._setModel(makeModel(this._model.error, this._model.loading, this._tableName, entities));
    };
    BaseEntitiesService.prototype._deleteInternalOneEntity = function (id) {
        var entities = this._model.entities.slice(0);
        var idx = list_1.$eidx(this._model.entities, id);
        if (idx !== -1) {
            entities.splice(idx, 1);
        }
        this._setModel(makeModel(this._model.error, this._model.loading, this._tableName, entities));
    };
    BaseEntitiesService.prototype._reloadEntityWithId = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var e;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._repo.getById(id)];
                    case 1:
                        e = _a.sent();
                        this._updateInternalOneEntity(e);
                        return [2 /*return*/, e];
                }
            });
        });
    };
    __decorate([
        Retainable_1.memLock
    ], BaseEntitiesService.prototype, "_init");
    __decorate([
        Retainable_1.memLock
    ], BaseEntitiesService.prototype, "_create");
    __decorate([
        Retainable_1.memLock
    ], BaseEntitiesService.prototype, "_updateOne");
    __decorate([
        Retainable_1.memLock
    ], BaseEntitiesService.prototype, "_remove");
    __decorate([
        Retainable_1.memLock
    ], BaseEntitiesService.prototype, "_reloadEntityWithId");
    return BaseEntitiesService;
}(BaseService_1.BaseService));
exports.BaseEntitiesService = BaseEntitiesService;
